import request from '@/request/ts-index';
import request2 from '@/request/ts-index2';
import qs from 'qs';
var MiguApi;
(function (MiguApi) {
    MiguApi["loginSecret"] = "/mobile/login/secret";
    MiguApi["ringStatus"] = "/mobile/ring/status";
    MiguApi["monthStatusV1"] = "/mobile/month/status/v1";
    MiguApi["monthStatusV2"] = "/mobile/month/status/v2";
    MiguApi["toneFreeOrderV1"] = "/mobile/tone/free/order/v1";
    MiguApi["toneFreeOrderV2"] = "/mobile/tone/free/order/v2";
    MiguApi["ringCallBack"] = "/mobile/ring/callback";
    MiguApi["unsubscribe"] = "/mobile/unsubscribe";
})(MiguApi || (MiguApi = {}));
export const loginSecret = (data) => {
    return request.post(MiguApi.loginSecret, qs.stringify(data));
};
// 彩铃功能状态
export const ringStatus = (params) => {
    return request.get(MiguApi.ringStatus, { params: params });
};
// 退订
export const miguUnsubscribe = (data) => {
    return request2.post(MiguApi.unsubscribe, data);
};
// 有功能包月状态 /无功能包月状态 根据channelCode传入渠道号判断
export const monthStatusV1 = (params) => {
    return request.get(MiguApi.monthStatusV1, { params: params });
};
// 有功能设置/无功能设置 根据渠道号判断
export const toneFreeOrderV1 = (data) => {
    return request.post(MiguApi.toneFreeOrderV1, qs.stringify(data));
};
// 绑定关系
export const ringCallBack = (data) => {
    return request.post(MiguApi.ringCallBack, qs.stringify(data));
};
